import { TextInput } from '@mantine/core';
import { ChangeEvent, useMemo } from 'react';
import { useIntl } from 'react-intl';

import styles from './EntityEmailInput.module.scss';

import { EMAIL_PATTERN } from 'utils/constants';
import sharedMessages from 'Components/utils/sharedMessages';
import { useEntityContext } from 'Screens/Dashboard/AllEntities/EntityProvider/EntityContext';

const EntityEmailInput = () => {
    const intl = useIntl();

    const { state, dispatch } = useEntityContext();

    const { email } = state;

    const isEmailValid = useMemo(() => EMAIL_PATTERN.test(email) || email.length === 0, [email]);

    const updateEmail = (evt: ChangeEvent<HTMLInputElement>) => {
        dispatch({ type: 'UPDATE_ENTITY_EMAIL', payload: evt.target.value });
    };

    return (
        <TextInput
            id="email"
            label={intl.formatMessage(sharedMessages.email)}
            placeholder={intl.formatMessage(sharedMessages.emailPlaceholder)}
            className={styles.textInput}
            type="text"
            maxLength={254}
            onChange={updateEmail}
            value={email}
            error={!isEmailValid ? intl.formatMessage(sharedMessages.incorrectEmail) : undefined}
            title={intl.formatMessage(sharedMessages.email)}
            radius="md"
        />
    );
};

export default EntityEmailInput;
